@import '../../stylesheets/defaults'

.mp-input-container, .mp-input-container *
  box-sizing border-box

.mp-input-container
  display flex
  flex-direction column
  font-weight $weight-regular
  max-height inherit
  width 300px

  &.is-readonly
    pointer-events none

  .input-label
    width fit-content

  .mp-input-field-container
    background-color var(--input-background-color, '%s' % var(--secondary-background-color))
    border 1px solid transparent
    border-color var(--input-border-color, '%s' % transparent)
    display flex
    max-height inherit
    position relative
    transition border-color 150ms $ease-out

    &:focus-within{$not-disabled}:not(.hide-focus-styling)
      background-color var(--background-color)
      border 1px solid var(--blue1)
      mp-focus-box-shadow()

    &:hover{$not-disabled}
      border 1px solid var(--blue1)

    &.size-large
      border-radius var(--input-border-radius, $border-radius-large)
      .mp-input
        border-radius var(--input-border-radius, $border-radius-large)
        font-size var(--input-font-size, $font-size-large)

    &.size-medium
      border-radius var(--input-border-radius, $border-radius-medium)
      .mp-input
        border-radius var(--input-border-radius, $border-radius-medium)
        font-size var(--input-font-size, $font-size-medium)

    &.size-small
      border-radius var(--input-border-radius, $border-radius-small)
      .mp-input
        border-radius var(--input-border-radius, $border-radius-small)
        font-size var(--input-font-size, $font-size-small)
        padding 0 var(--input-padding)

    &.is-valid
      &:focus-within{$not-disabled}
        border 1px solid var(--green1)
        mp-focus-box-shadow(var(--green1-rgb))

      &:hover{$not-disabled}
        border 1px solid var(--green1)

    &.is-invalid
      &:focus-within{$not-disabled}
        background-color var(--background-color)
        border 1px solid var(--orange1)
        mp-focus-box-shadow(var(--orange1-rgb))

      &:hover{$not-disabled}
        border 1px solid var(--orange1)

    &:not(.has-multiline-prefix).has-min-input-width
      .mp-input-wrapper
        overflow auto
        padding-left 6px
        white-space nowrap
        // prevents scrollbar from showing up to mimic a native input element
        webkit-scrollbar-styles(size=0px)

        input.mp-input
          flex 1 1 auto

    &.has-multiline-prefix
      .mp-input-wrapper
        column-gap 6px
        flex-wrap wrap
        padding 6px
        row-gap 6px

        input.mp-input
          align-self stretch
          flex 0 1 auto
          height initial
          padding 0 2px 0 2px

    {$disabled}
      border none
      color var(--tertiary-text-color)
      cursor not-allowed
      opacity 0.5

      .mp-input-wrapper
        cursor not-allowed

    .mp-input-numeric-arrow-controls
      display none
      flex-direction column

      .numeric-arrow-button
        --button-padding 0
        color var(--secondary-text-color)

    .mp-input-left-area, .mp-input-right-area
      align-items center
      display flex

      > *
        display flex

    .mp-input-right-area
      margin-left auto

    .mp-input-pre-text, .mp-input-action-text
      color var(--tertiary-text-color)
      font-size var(--input-action-text-font-size, $font-size-small)
      user-select none
      white-space nowrap

    .mp-input-left-area
      .mp-input-left-icon
        color var(--tertiary-text-color)

      .mp-input-pre-text
        font-family $family-mono

      .mp-input-left-icon, .mp-input-pre-text
        margin-left 4px

    // tag input
    .mp-input-wrapper
      align-items center
      cursor text
      display flex
      flex 1
      min-width 0

      input.mp-input
        flex 1

    .mp-input-right-area
      > *
        margin-right 8px

      .mp-input-right-icon
        &.custom-right-icon
          color var(--tertiary-text-color)
        &.valid
          color var(--green1)
        &.invalid
          color var(--orange1)
        &.clickable
          cursor pointer

    .mp-input-clickable-icon
      color var(--secondary-text-color)
      &:hover
        color var(--blue1)

  .mp-input-error-message
    color var(--orange1)
    font-size $font-size-small
    margin-top 5px
    padding-left 5px

  input.mp-input, textarea.mp-input
    background-color inherit
    border none
    border-radius inherit
    color inherit
    font-family inherit
    font-size inherit
    font-weight inherit
    height 100%
    margin var(--input-margin, 0)
    padding 8px
    text-align inherit
    text-overflow ellipsis
    width 100%

  .mp-input-field-container.type-text, .mp-input-field-container.type-password, .mp-input-field-container.type-number
    input-field-height(line-height)
      &:not(.has-multiline-prefix)
        height line-height

      &.has-multiline-prefix
        min-height line-height

    &.size-large
      input-field-height(40px)

    &.size-medium
      input-field-height(32px)

    &.size-small
      input-field-height(24px)

    max-height inherit

  .mp-input-field-container.type-number
    -moz-appearance textfield

    // explicitly hide arrow buttons in standard number input, requested by designers
    input.mp-input::-webkit-outer-spin-button, input.mp-input::-webkit-inner-spin-button
      -webkit-appearance none
      margin 0

    input.mp-input::placeholder
      color var(--input-number-placeholder-color, '%s' % var(--blue1)) !important

    input.mp-input:focus+.mp-input-numeric-arrow-controls
      display flex

  textarea.mp-input
    height var(--input-size, 120px)
    resize none


  &.theme-white
    .mp-input-field-container
      background-color var(--gray0)
